import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { confirmacionesApi } from '../api/confirmaciones';
import { toast } from 'sonner';

export function useConfirmaciones(params?: { 
  fechaInicio?: string; 
  fechaFin?: string; 
  cliente?: string;
  incluirOcultos?: boolean;
}) {
  return useQuery({
    queryKey: ['confirmaciones', 'entregas', params],
    queryFn: () => confirmacionesApi.getEntregas(params),
    staleTime: 1000 * 60 * 2,
    refetchInterval: 1000 * 15,
    refetchIntervalInBackground: true,
  });
}

export function useConfirmacion(id: number) {
  return useQuery({
    queryKey: ['confirmaciones', 'entrega', id],
    queryFn: () => confirmacionesApi.getEntrega(id),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useEnviarEmailConfirmacion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: { asunto: string; mensaje: string; adjuntarFactura: boolean } }) =>
      confirmacionesApi.enviarEmail(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmaciones'] });
      toast.success('Email de confirmación enviado');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al enviar el email');
    },
  });
}

export function useGuardarFactura() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, facturaUrl }: { id: number; facturaUrl: string }) =>
      confirmacionesApi.guardarFactura(id, facturaUrl),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmaciones'] });
      toast.success('Factura guardada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al guardar la factura');
    },
  });
}

export function useOcultarConfirmacion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => confirmacionesApi.ocultar(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmaciones'] });
      toast.success('Tarjeta ocultada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al ocultar la tarjeta');
    },
  });
}

export function useConfirmacionesStats() {
  return useQuery({
    queryKey: ['confirmaciones', 'stats'],
    queryFn: () => confirmacionesApi.getEstadisticas(),
    staleTime: 1000 * 60 * 5,
  });
}